import React from "react";

const ChatStartEndDay = ({ dayTime }) => {
  return (
    <>
      <div className="clear-both" />
      <div className="mt-5 mb-6 text-xs text-center text-slate-500 intro-y font-medium">
        {dayTime}
      </div>
    </>
  );
};

export default ChatStartEndDay;
